import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspaceInfoBasicFragment = { __typename?: 'Workspace', id: string, name: string, projectNotificationsEnabled?: boolean | null, isWorkfront?: boolean | null, visibleActiveProjectCount?: number | null, visibleInactiveProjectCount?: number | null, externallyManagedIntegration?: { __typename?: 'ExternallyManagedIntegration', integration?: Types.Integration | null, canUpdateInternalAssetContentSecurity: boolean, canUpdateWorkspaceName: boolean } | null, images?: { __typename?: 'Images', image128?: string | null, original?: string | null } | null, permissions?: { __typename?: 'WorkspacePermissions', canCreateProject: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean } | null };

export const WorkspaceInfoBasic = /*#__PURE__*/ gql`
    fragment WorkspaceInfoBasic on Workspace {
  externallyManagedIntegration @client {
    integration
    canUpdateInternalAssetContentSecurity
    canUpdateWorkspaceName
  }
  id
  name
  projectNotificationsEnabled
  images {
    image128
    original
  }
  isWorkfront
  permissions {
    canCreateProject
    canEditUserPermissions
    canManageResourceControlPolicies
  }
  visibleActiveProjectCount: projectCount(filter: {status: ACTIVE})
  visibleInactiveProjectCount: projectCount(filter: {status: INACTIVE})
}
    ` as unknown as DocumentNode<WorkspaceInfoBasicFragment, unknown>;

        

        
export const useWorkspaceInfoBasicFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceInfoBasicFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceInfoBasicFragment>({
    fragment: WorkspaceInfoBasic,
    fragmentName: 'WorkspaceInfoBasic',
    ...options,
  });
};
  
        